import React, { useState, useEffect } from 'react';

function LangButton() {
  // localStorage에서 언어 가져오기 (없으면 기본 'en')
  const [language, setLanguage] = useState(localStorage.getItem('preferredLang') || 'en');

  useEffect(() => {
    localStorage.setItem('preferredLang', language);
  }, [language]);

  // 버튼 클릭 시 'ko' ↔ 'en' 토글 후 새로고침
  const toggleLanguage = () => {
    const newLanguage = language === 'ko' ? 'en' : 'ko';
    localStorage.setItem('preferredLang', newLanguage);
    setLanguage(newLanguage);
    window.location.reload(); // 페이지 새로고침
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center justify-center w-8 group"
    >
      {/* 한국어 아이콘 */}
      <img
        src={require("../assets/icon/lang.png")}
        className="absolute h-4 opacity-100 group-hover:opacity-0 transition-opacity duration-300"
        alt="Korean Language"
      />
      {/* 영어 아이콘 */}
      <img
        src={require("../assets/icon/eng.png")}
        className="absolute h-5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
        alt="English Language"
      />
    </button>
  );
}

export default LangButton;
